module.exports = __webpack_public_path__ + "static/assets/859706dba445d05611b8c2e12f8da374.svg";